export default function SocialsCTA() {
  return (
    <section className="py-24 px-6 bg-gradient-to-br from-blue-500 to-blue-600">
      <div className="max-w-5xl mx-auto text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Join Our Growing <strong>Community</strong>
        </h2>
        <p className="text-xl mb-12 max-w-3xl mx-auto leading-relaxed">
          Be part of thousands of homeowners who trust Brushour for their painting and decorating needs. Follow us today and never miss an update, special offer, or inspiration!
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
          <a
            href="https://www.instagram.com/brushour_"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="fab fa-instagram mr-2"></i>
            Follow on Instagram
          </a>
          <a
            href="https://www.facebook.com/brushour"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="fab fa-facebook mr-2"></i>
            Like on Facebook
          </a>
          <a
            href="https://www.youtube.com/@brushour"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="fab fa-youtube mr-2"></i>
            Subscribe on YouTube
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">5K+</div>
            <div className="text-sm opacity-90">Instagram Followers</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">3.2K+</div>
            <div className="text-sm opacity-90">Facebook Fans</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">1.8K+</div>
            <div className="text-sm opacity-90">YouTube Subscribers</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">2.5K+</div>
            <div className="text-sm opacity-90">Pinterest Followers</div>
          </div>
        </div>
      </div>
    </section>
  );
}
